import Const from 'constants';

class State {
    data;
    constructor(data = {}) {
        this.data = data;
    }
    all = () => ({...this.data});
    hasRunSettingsByKey = (key) => this.data.hasOwnProperty(key);
    getRunSettingsByKey = (key) => {
        if (this.hasRunSettingsByKey(key)) {
            return {...this.data[key]};
        }
        return {};
    };
}

const defaultState = new State();

export default function (state = defaultState, action) {
    if (action.type === Const.SAVE_RUN_SETTINGS) {
        state = new State({...state.data, [action.key]: {...action.settings}});
    }

    return state;
}
